'use strict';

angular.module('mobile-apps').factory('Mau', ['$resource',
    function($resource) {
        return $resource(
          'v1/mau'
        );
    }
]);